// import { Link } from "react-router-dom";
import { useMenu } from "../context/MenuContext";
import { useLoader } from "../context/LoaderContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";

const Navbar = () => {
  const { menuOpen, setMenuOpen } = useMenu();
  const { setLoading } = useLoader();
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };
  const linkClicker = (path: string) => {
    const currentPath = window.location.pathname;
    const pathLocation =
      path === "/" ? currentPath === "/" : currentPath.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  const { companyDetailsData } = useCompanyDetailsContext();
  // const isContactOrTermsPage =
  //   window.location.pathname.includes("contact") ||
  //   window.location.pathname.includes("termscondition");
  // const isContact = window.location.pathname.includes("contact");
  const isTermsPage =
    window.location.pathname.includes("terms-and-condition") ||
    window.location.pathname.includes("faqs");
  const isBooking = window.location.pathname.includes("booking");
  const logo_white = companyDetailsData[0]?.primary_logo_color?.[0]?.media?.url
    ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color?.[0]?.media?.url}`
    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png";
  const blacklogo = companyDetailsData[0]?.secondary_logo_color?.[0]?.media?.url
    ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.secondary_logo_color?.[0]?.media?.url}`
    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png";
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
      >
        <div id="perspective">
          <div
            id="wrapper"
            className={`${
              !isTermsPage && !isBooking ? "hasbg transparent" : "custom-hasbg"
            }`}
          >
            <div
              className={`${
                !isTermsPage && !isBooking ? "header_style_wrapper" : ""
              }`}
            >
              <div
                className={`top_bar ${
                  !isTermsPage && !isBooking ? "hasbg" : ""
                }`}
              >
                <div
                  id="logo_wrapper"
                  // style={{ marginTop: isContact ? "-60px" : "unset" }}
                >
                  <div id="menu_wrapper">
                    <div id="nav_wrapper">
                      <div className="nav_wrapper_inner">
                        <div
                          id="menu_border_wrapper"
                          style={{ display: "inline-flex" }}
                        >
                          <button
                            id="mobile_nav_icon"
                            onClick={handleMenuClick}
                            style={{
                              cursor: "pointer",
                              background: "transparent",
                              border: "unset",
                            }}
                          >
                            <span className="ti-menu custom-ti-menu"></span>
                          </button>

                          <div className="menu-main-menu-container">
                            <ul id="main_menu" className="nav">
                              <li className="menu-item">
                                <Link
                                  to="/our-rooms"
                                  onClick={() => linkClicker("our-rooms")}
                                >
                                  Reservation
                                </Link>
                              </li>
                              <li className="menu-item menu-item-has-children arrow">
                                <Link to="#">Explore</Link>
                                <ul className="sub-menu">
                                  {/* <li className="menu-item">
                                    <Link to="/" onClick={()=>linkClicker("")}>Home</Link>
                                  </li> */}
                                  <li className="menu-item">
                                    <Link
                                      id="our-rooms"
                                      className="menu-item"
                                      to="/our-rooms"
                                      onClick={() => linkClicker("our-rooms")}
                                    >
                                      Our Rooms
                                    </Link>
                                  </li>
                                  {/* <li className="menu-item">
                                    <span
                                      className="disabled-link"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Special Offers
                                    </span>
                                  </li> */}
                                  {/* <li className="menu-item">
                                    <Link to="/aboutus">About Us</Link>
                                  </li> */}
                                  <li className="menu-item">
                                    <Link
                                      to="/contact"
                                      onClick={() => linkClicker("contact")}
                                    >
                                      Contact
                                    </Link>
                                  </li>
                                  {/* <li className="menu-item">
                                    <Link to="/">Testimonial</Link>
                                  </li>
                                  <li className="menu-item">
                                    <Link to="/">Restaurant</Link>
                                  </li>
                                  <li className="menu-item">
                                    <Link to="/">Blog</Link>
                                  </li>
                                  <li className="menu-item">
                                    <Link to="/">Explore</Link>
                                  </li>
                                  <li className="menu-item">
                                    <Link to="/">My Bookings</Link>
                                  </li> */}
                                  {/* <li className="menu-item">
                                    <Link to="/gallery">Gallery</Link>
                                  </li>
                                  <li className="menu-item">
                                    <Link to="/termscondition">
                                      Terms and Conditions
                                    </Link>
                                  </li> */}
                                </ul>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="logo_right_button">
                    {/* <div className="header_client_wrapper">
                      <Link className="client_login_link" to="/" title="Login">
                        <span className="ti-lock"></span>Login
                      </Link>
                    </div> */}

                    <div className="header_call_wrapper">
                      <span className="ti-mobile"></span>
                      <Link
                        className="tooltip"
                        to={`tel:${companyDetailsData[0]?.mobile_number}`}
                        title="Call Us"
                      >
                        {companyDetailsData[0]?.mobile_number}
                      </Link>
                      <span
                        className="ti-layout-line-solid"
                        style={{
                          display: "inline-block",
                          transform: "rotate(90deg)",
                          marginRight: "unset",
                        }}
                      ></span>
                      <Link
                        className="tooltip"
                        to={`tel:${companyDetailsData[0]?.telephone_number}`}
                        title="Call Us"
                      >
                        {companyDetailsData[0]?.telephone_number}
                      </Link>
                    </div>
                  </div>

                  <div id="logo_normal" className="logo_container">
                    <div className="logo_align">
                      <Link
                        id="custom_logo"
                        className="logo_wrapper hidden"
                        to="/"
                        onClick={() => linkClicker("/")}
                      >
                        <img
                          src={
                            isTermsPage || isBooking ? blacklogo : logo_white
                          }
                          alt="hotel_bayberry"
                          width="103"
                          height="160"
                        />
                      </Link>
                    </div>
                  </div>

                  <div id="logo_transparent" className="logo_container">
                    <div className="logo_align">
                      <Link
                        id="custom_logo_transparent"
                        className="logo_wrapper default"
                        to="/"
                        onClick={() => linkClicker("/")}
                      >
                        <img
                          src={
                            isTermsPage || isBooking ? blacklogo : logo_white
                          }
                          alt="hotel_bayberry"
                          height="160"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default Navbar;
